import BaseModel from './BaseModel'

export default class Supplier extends BaseModel {
  // ... Supplier-specific methods or overrides ...
}
